import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MessagesSquare } from "lucide-react";

export function DiscussButton({ contextType, contextId, label, variant = "outline", size = "sm", className = "", iconOnly = false }) {
  const qc = useQueryClient();
  const navigate = useNavigate();

  const mut = useMutation({
    mutationFn: () => api.post("/chat/context", { context_type: contextType, context_id: contextId, label }),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ["chat-channels"] });
      navigate(`/app/chat?c=${res.data.id}`);
    },
    onError: (e) => toast.error(e.response?.data?.detail || "Could not open discussion"),
  });

  return (
    <Button
      variant={variant}
      size={iconOnly ? "icon" : size}
      className={className}
      disabled={mut.isPending}
      onClick={(e) => { e.stopPropagation(); mut.mutate(); }}
      data-testid={`discuss-${contextType}-${contextId}`}
      title="Discuss in Team Chat"
    >
      <MessagesSquare className={iconOnly ? "h-4 w-4" : "mr-1 h-3.5 w-3.5"} />
      {!iconOnly && "Discuss"}
    </Button>
  );
}
